import styled from "styled-components";
import {deviceDF} from 'assets/breakPoints'

export const SelectRoot = styled.div`
   display: flex;
   position: relative;
   justify-content: space-between;
   color: hsl(0deg 0% 0% / 87%);
   font-size: 1rem;
   font-family: "Roboto", "Helvetica", "Arial", sans-serif;
   align-items: center;
   font-weight: 400;
   line-height: 1.1876em;  
   margin: 20px auto;
   width: 100%;
   gap: 10px;
`

export const SelectStyled = styled.select`
   width: 100%;
   height: 40px;
   border-left-style: none;
   border-right-style: none;
   border-top-style: none;
   border-bottom-color: ${props => 
   props.requiredField === 'error' 
   ? "#e63946" 
   : "#999999"};
   font-size: 18px;
   outline: none;
   margin: 0px 20px;// mobile L 20px
   min-width: 0;
   box-sizing: content-box;
   letter-spacing: inherit;
   background: transparent;
   font-family: "Red Hat Display",Sans-serif;
   &::placeholder {
      color: #6c757d;
      font-family: "Red Hat Display", Sans-serif;
   }
   
  &:focus {
      outline: none;
      box-shadow: 0px 0px 2px red;
   }

   @media ${deviceDF.mobileL} {
      width: 100%;
   }
`